module.exports = __webpack_public_path__ + "img/green-check-14.b6cbcffa.svg";